module.exports = __webpack_public_path__ + "img/MegaMillionslogo.b0e0f739.png";